<div class="branches">
  <h2>{{ content.title | translate }}</h2>
  <ul>
    <li *ngFor="let item of content.list | translate">
      <a [href]="getLink(item)" target="_blank">{{ item }}</a>
    </li>
  </ul>
</div>
